import api from './api';

export const registryApi = {
  // Service catalog (paginated, filterable)
  listServices: (params = {}) =>
    api.get('/registry/services', { params }),

  // Single service detail
  getService: (id) =>
    api.get(`/registry/services/${id}`),

  // Dependencies for a service
  getDependencies: (id) =>
    api.get(`/registry/services/${id}/dependencies`),

  // Blast radius (recursive impact)
  getBlastRadius: (id) =>
    api.get(`/registry/services/${id}/blast-radius`),

  // Live AWS health metrics
  getServiceHealth: (id) =>
    api.get(`/registry/services/${id}/health`, { timeout: 60000 }),

  // All components (paginated)
  listComponents: (params = {}) =>
    api.get('/registry/components', { params }),

  // Full dependency graph
  getGraph: () =>
    api.get('/registry/graph'),

  // Gap report
  getGaps: () =>
    api.get('/registry/gaps'),

  // Runbook (markdown from disk)
  getRunbook: (serviceId) =>
    api.get(`/registry/runbooks/${serviceId}`),
};
